export const MODAL_TEST_ID = {
    OVERLAY: 'modal-overlay',
    DIALOG: 'modal-dialog',
    CONTENT: 'modal-content',
    HEADER: 'modal-header',
    BODY: 'modal-body',
    BODY_CONTENT: 'modal-body-content',
    FOOTER: 'modal-footer',
    TITLE: 'modal-title',
    SUBTITLE: 'modal-subtitle',
};
